export const assessmentKitFilter = [
    "all",
    "assigned",
    "accepted",
    "completed",
    "submitted",
    "decline",
  ];
  